import { BrandName } from '@packlink/brands';
import { useCdnUrl } from '@packlink/provider';
import { useTenantConfig } from '@packlink/tenant-config-provider';
import { useMemo, useCallback } from 'react';

let BrandAssetType = /*#__PURE__*/function (BrandAssetType) {
  BrandAssetType["LOGO"] = "logos";
  BrandAssetType["FAVICON"] = "favicons";
  return BrandAssetType;
}({});
let BrandLogo = /*#__PURE__*/function (BrandLogo) {
  BrandLogo["LOGO"] = "logo.svg";
  BrandLogo["LOGO_ALT"] = "logo-alt.svg";
  return BrandLogo;
}({});
let BrandFavicon = /*#__PURE__*/function (BrandFavicon) {
  BrandFavicon["ANDROID_CHROME_192"] = "android-chrome-192.png";
  BrandFavicon["APPLE_TOUCH_152"] = "apple-touch-icon-152.png";
  BrandFavicon["APPLE_TOUCH_167"] = "apple-touch-icon-167.png";
  BrandFavicon["APPLE_TOUCH_180"] = "apple-touch-icon-180.png";
  BrandFavicon["FAVICON_16"] = "favicon-16.png";
  BrandFavicon["FAVICON_32"] = "favicon-32.png";
  BrandFavicon["FAVICON_128"] = "favicon-128.png";
  BrandFavicon["FAVICON_196"] = "favicon-196.png";
  return BrandFavicon;
}({});
/**
 * Return a function to get favicon or logo from CDN.
 * Example urls
 * https://cdn.packlink.com/brand/ebay/logos/logo.png
 *
 */
function useAssetUrl(assetType) {
  const {
    brand
  } = useTenantConfig() || {
    brand: BrandName.FALLBACK
  };
  const cdnUrl = useCdnUrl();
  const baseUrl = useMemo(() => `${cdnUrl}/brand/${brand}`, [brand, cdnUrl]);
  const getAsset = useCallback(asset => `${baseUrl}/${assetType}/${asset}`, [assetType, baseUrl]);
  return getAsset;
}

export { BrandAssetType, BrandFavicon, BrandLogo, useAssetUrl };
//# sourceMappingURL=useAsset.js.map
